export default __webpack_public_path__ + "static/media/br_cnh_front.bacf98af.jpeg";